module.exports = __webpack_public_path__ + "img/pic_lingong.1f8d16d9.png";